export class DrugRoute {
  code = null;
  name = null;
  description = null;
}
